import * as React from 'react'
import { Segment, Card } from 'semantic-ui-react'
import { IngotItem } from './IngotItem'

type ItemDeckProps = {
    items: IIngotItemInfo[],
    onClickItem: ICallback2<IIngotItemInfo>,
}

export const ExchangeStoreDeck: React.SFC<ItemDeckProps> = (props) => {
    const { items, onClickItem } = props
    return (
        <Segment style={{overflow: 'auto', maxHeight: '500px', border: 'none'}}>
            <Card.Group>
                {items.map(item => <IngotItem key={item.id} gameItem={item} onClickItem={() => onClickItem(item)}/>)}
            </Card.Group>
        </Segment>
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/ExchangeStore/ExchangeStoreDeck.tsx